import React, { useState } from "react";
import { Button, Upload, App } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { prepareCoverUpload } from "../../../../services/formacion/formacion.service";
import { uploadFileToSignedUrl } from "../../../../utils/uploadFileToSignedUrl";

const ACCEPTED_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

interface Props {
  schoolId: number | null;
  trainingId: number;
  value?: string | null;
  onChange?: (url: string | null) => void;
}

const CoverUploadInput: React.FC<Props> = ({
  schoolId,
  trainingId,
  value,
  onChange,
}) => {
  const { message } = App.useApp();
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (file: File) => {
    if (!ACCEPTED_TYPES.includes(file.type)) {
      message.error("Formato no soportado. Usá PNG, JPG o WEBP.");
      return false;
    }
    setUploading(true);
    try {
      const { signedUrl, url } = await prepareCoverUpload(
        schoolId,
        trainingId,
        file.type
      );
      await uploadFileToSignedUrl(signedUrl, file);
      onChange?.(url);
      message.success("Portada subida");
    } catch (error) {
      console.error(error);
      message.error("Error al subir la portada");
    } finally {
      setUploading(false);
    }
    return false;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        {value && (
          <img
            src={value}
            alt="Portada"
            style={{
              width: 56,
              height: 56,
              objectFit: "cover",
              borderRadius: 6,
            }}
          />
        )}
        <Upload
          beforeUpload={handleUpload}
          showUploadList={false}
          accept="image/png,image/jpeg,image/webp"
        >
          <Button icon={<UploadOutlined />} loading={uploading}>
            {value ? "Reemplazar portada" : "Subir portada"}
          </Button>
        </Upload>
        {value && (
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onChange?.(null)}
          />
        )}
      </div>
      <span
        style={{
          fontSize: 12,
          lineHeight: 1.4,
          color: "var(--bo-text-secondary)",
        }}
      >
        Cuadrada, 512×512 px. PNG, JPG o WEBP. Se recorta desde el centro.
      </span>
    </div>
  );
};

export default CoverUploadInput;
